import * as React from 'react';

export function WidgetPreview() {
    return [
        <div className="widget" key="widget-preview">
            <div className="widget-inner-container">
                <div className="widget-control-panel">
                    <span>{'Sample Widget'}</span>
                    <span className="glyphicon glyphicon-option-horizontal menu-button header-button"></span>
                </div>
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas-main p-3">{'Widget Content Here'}</div>
            </div>
        </div>
    ];
}
